{
 "z01-grain-court": {"perspective": [270, 820, 0.96, 1.08], "ground": [880, 610], "haze": [980, 60], "fog": 0.08},
 "z01-basilica": {"perspective": [270, 820, 0.98, 1.08], "ground": [1060, 620], "haze": [1380, 120], "fog": 0.06},
 "z01-archive-stair": {"perspective": [100, 780, 0.92, 1.06], "ground": [830, 670], "haze": [1180, 160], "fog": 0.05},
 "z01-river-bridge": {"perspective": [120, 860, 0.9, 1.06], "ground": [560, 480], "haze": [1100, 90], "fog": 0.12}
}
